import { Directive, HostListener, Input, inject } from '@angular/core';
import { IProductData, Product } from '@df/catalog/product/product';
import { Meta } from '@df/core/meta/meta';
import { AdvancedCommerce } from '../advanced-commerce.namespace';
import { AdvancedCommerceTrackService } from './advanced-commerce-track.service';

/**
 * @example
 * ```html
 * <a ... [acTrackClick]="model" [acClickCode]="acClickCode">...</a>
 * ```
 */
@Directive({
    selector: '[acTrackClick],[advancedCommerceTrackClick]',
    standalone: true
})
export class AdvancedCommerceTrackClickDirective {
    @Input()
    set acTrackClick(value: Product<IProductData> | string | number | undefined) {
        this.model = value;
    }

    @Input()
    set advancedCommerceTrackClick(value: Product<IProductData> | string | number | undefined) {
        this.model = value;
    }

    @Input()
    acClickCode?: string;

    protected model?: Product<IProductData> | string | number;

    protected meta = inject(Meta);
    protected trackService = inject(AdvancedCommerceTrackService);

    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        if (this.model) {
            const metaModel = this.meta.model;

            const data: Partial<AdvancedCommerce.Track.RequestData<AdvancedCommerce.Track.DataView>> = {
                data: {
                    product_id: `${typeof this.model === 'string' || typeof this.model === 'number' ? this.model : this.model.parent.id}`
                },
                context: { click_code: this.acClickCode }
            };

            if (data.context) {
                if (metaModel?.type === 'category') {
                    data.context.category_id = `${metaModel.id}`;
                } else if (metaModel?.type === 'page') {
                    data.context.page_id = `${metaModel.id}`;
                }
            }

            this.trackService.trackClick(data);
        }
    }
}
